import React from 'react';
import PropTypes from 'prop-types';
import PartialTable from 'components/partials/PartialTable';
import { formatDateddMMyyyy } from 'helpers/dateHelper';
import UsersInCellWidget from 'components/common/users/UsersInCellWidget';

const MyVisitHisTable = ({
  data,
  paging,
  total,
  nextPage,
  previousPage,
  gotoPage,
  handleClickRow,
  onPageSizeChange
}) => {
  const columns = [
    {
      accessor: 'id',
      Header: 'ID',
      isVisible: false
    },
    {
      accessor: 'visitDate',
      Header: 'Visit Date',
      Cell: rowData => {
        const { visitDate } = rowData.row.original;
        return formatDateddMMyyyy(visitDate);
      }
    },
    {
      accessor: 'customerName',
      Header: 'Customer Name'
    },
    {
      accessor: 'visitType',
      Header: 'Visit Type',
      Cell: rowData => {
        const { visitType } = rowData.row.original;
        if (visitType == 0) return 'Prospect';
        if (visitType == 1) return 'New Customer';
        return 'Old Customer';
      }
    },
    {
      accessor: 'saleUserId',
      Header: 'Account Manager',
      Cell: rowData => {
        const { saleUserId } = rowData.row.original;
        return (
          <UsersInCellWidget usersText={saleUserId?.toString()} showName />
        );
      }
    }
  ];

  return (
    <>
      <PartialTable
        data={data}
        columns={columns}
        paging={paging}
        total={total}
        nextPage={nextPage}
        previousPage={previousPage}
        gotoPage={gotoPage}
        onPageSizeChange={onPageSizeChange}
        handleClickRow={handleClickRow}
        textAlign=""
      />
    </>
  );
};

MyVisitHisTable.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object),
  paging: PropTypes.object,
  total: PropTypes.number,
  nextPage: PropTypes.func,
  previousPage: PropTypes.func,
  gotoPage: PropTypes.func,
  onPageSizeChange: PropTypes.func,
  handleClickRow: PropTypes.func
};

export default MyVisitHisTable;
